var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 44,
  height: 44,
  "aria-hidden": "true"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "delivery_svg__a",
  d: "M10.035 30H7V12h21l1 2h5c1.667 2.657 5 7 5 7v9h-3.115c-.164 1.653-1.34 3-3.369 3s-3.279-1.424-3.367-3H16.965a3.5 3.5 0 0 1-6.93 0m6.63-1.995a3.5 3.5 0 0 0-6.33-.002M37 25v3h-1.142q-1.077-1.957-3.285-1.975-2.341-.018-3.424 1.975H29V16h4l4 6zm-.651-4 .652 1H31v-4h3.325l1.71 2.556zM9 14h18v14H9zm23.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-19 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m22.535-7.444L34.935 19H32v2h4.332z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#delivery_svg__a",
  fill: "#2D2D2D",
  fillRule: "evenodd"
})));
export default SvgDelivery;